import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';

import { EstablishmentStore } from '../store/establishment.store';

export const establishmentGuard: CanActivateFn = () => {
  const establishmentStore = inject(EstablishmentStore);
  const router = inject(Router);

  // If already loaded, check immediately
  const establishments = establishmentStore.establishments();
  const currentEstablishment = establishmentStore.currentEstablishment();
  const isLoading = establishmentStore.isLoading();

  // If not loading and we have data, check now
  if (!isLoading && (establishments.length > 0 || currentEstablishment)) {
    return true;
  }

  // If not loading and no data, redirect to onboarding
  if (!isLoading && establishments.length === 0 && !currentEstablishment) {
    return router.createUrlTree(['/onboarding/setup']);
  }

  // If loading, wait for it to complete then check
  return toObservable(establishmentStore.isLoading).pipe(
    filter((loading) => !loading), // Wait until loading is false
    take(1),
    map(() => {
      const loadedEstablishments = establishmentStore.establishments();
      const loadedCurrent = establishmentStore.currentEstablishment();

      if (loadedEstablishments.length === 0 && !loadedCurrent) {
        return router.createUrlTree(['/onboarding/setup']);
      }
      return true;
    }),
  );
};
